import { FDealType, FOfferType, isAvailable } from '@/packages/JsonQuery';

import { SpecialOffersContainer } from '../../containers/advancedFilters/SpecialOffersContainer';
import { type IFilter } from '../../types/advancedFilters';

export const specialOffers: IFilter = {
  component: SpecialOffersContainer,
  // Новостроечная и смешанная выдача.
  availability: ({ jsonQuery }) => isAvailable(FDealType.Sale, FOfferType.FlatNew)(jsonQuery),
};
